import { useContext, useEffect, useState, useMemo } from 'react';

//Components
import LinkedIncidentTable from './LinkedIncidentTable'
import { Modal } from '@material-ui/core'

//Contexts
import { UserContext } from '../Contexts/UserContext'
import { IncidentsContext } from '../Contexts/IncidentsContext'
import { INCIDENT_ACTIONS } from '../Actions/IncidentActions'

//Fetching
import { useMutation, useLazyQuery } from '@apollo/client';
import { REMOVE_LINKED_INCIDENT } from '../Mutations/RemoveLinkedIncident'
import { REMOVE_RELATED_INCIDENT } from '../Mutations/RemoveRelatedIncident'
import { GET_LINKED_INCIDENTS } from '../Queries/GetLinkedIncidents'
import { GET_RELATED_INCIDENTS } from '../Queries/GetRelatedIncidents'

//Styling
import '../Styles/resizable.css'
import { shouldBeLocked } from '../utils/Roles';

const LinkedIncidents = ({ handleIncidentOpening, showLinkedIncidents, setShowLinkedIncidents, modalStyle, formStyle, fabStyle, paperStyle, linkedIncidents, relatedIncidents, incidentId, incidentIndex, disabled = undefined, userRoles, ...props }) => {
  const memoizedLocked = useMemo(() => shouldBeLocked(disabled, props?.canEdit, userRoles), [disabled, props?.canEdit, userRoles]);
  const [showColumn, setShowColumn] = useState({
    incidentNumber: true,
    name: true,
    callTime: true,
    primaryOfficer: true,
    occurredFrom: true,
    occurredTo: true,
    remove: true,
  })

  const { incidentDispatch } = useContext(IncidentsContext)

  const handleShowColumn = (e) => {
    const name = e.target.value
    const bool = e.target.checked

    setShowColumn(prevState => {
      return { ...prevState, [name]: bool }
    })
  }
  const { user, responseErrorHandler } = useContext(UserContext)
  const { UPDATE_INCIDENT } = INCIDENT_ACTIONS
  const [removeLinkedIncident] = useMutation(REMOVE_LINKED_INCIDENT)
  const [removeRelatedIncident] = useMutation(REMOVE_RELATED_INCIDENT)

  const [getLinkedIncidents, { loading: linkedLoading, data: linkedData }] = useLazyQuery(GET_LINKED_INCIDENTS, {
    context: { serializationKey: "incidentQueue" },
    fetchPolicy: 'no-cache',
    variables: { incidentId: incidentId, originatorId: user?.id },
    onCompleted: (data) => {
      if (data) {
        responseErrorHandler(data)
        let res = data[Object.keys(data)[0]]
        incidentDispatch({ type: UPDATE_INCIDENT, payload: { id: incidentId, incidentIndex: incidentIndex, property: 'linkedIncidents', value: res.linkedIncidents } })
      }
    }
  })

  const [getRelatedIncidents] = useLazyQuery(GET_RELATED_INCIDENTS, {
    context: { serializationKey: "incidentQueue" },
    fetchPolicy: 'no-cache',
    variables: { incidentId: incidentId, originatorId: user?.id },
    onCompleted: (data) => {
      if (data) {
        responseErrorHandler(data)
        let res = data[Object.keys(data)[0]]
        incidentDispatch({ type: UPDATE_INCIDENT, payload: { id: incidentId, incidentIndex: incidentIndex, property: 'relatedIncidents', value: res.relatedIncidents } })
      }
    }
  })

  useEffect(() => {
    if (showLinkedIncidents) {
      getLinkedIncidents();
      getRelatedIncidents()
    }
  }, [showLinkedIncidents, getLinkedIncidents, getRelatedIncidents])


  const handleRemoveLinkedIncident = (id) => {
    removeLinkedIncident({ variables: { input: { incidentId: incidentId, linkedIncidentId: id, originatorId: user?.id } } })
    let newIncidents = linkedIncidents.filter(linkedIncident => linkedIncident.id !== id)
    incidentDispatch({ type: UPDATE_INCIDENT, payload: { id: incidentId, incidentIndex: incidentIndex, property: 'linkedIncidents', value: newIncidents } })
  }

  const handleRemoveRelatedIncident = (id) => {
    let newIncidents = relatedIncidents.filter(relatedIncident => relatedIncident.id !== id)
    incidentDispatch({ type: UPDATE_INCIDENT, payload: { id: incidentId, incidentIndex: incidentIndex, property: 'relatedIncidents', value: newIncidents } })
    removeRelatedIncident({ variables: { input: { incidentId: id, originatorId: user?.id } } })
  }

  const linkedHeaders = [
    { title: 'Incident Number', idName: 'incidentNumber', show: showColumn.incidentNumber },
    { title: 'Call\xa0Type', idName: 'name', show: showColumn.name },
    { title: 'Call\xa0Date/Time', idName: 'callTime', show: showColumn.callTime },
    { title: 'Officer', idName: 'primaryOfficer', show: showColumn.primaryOfficer },
    // { title: 'From', idName: 'occurredFrom', show: showColumn.occurredFrom },
    // { title: 'To', idName: 'occurredTo', show: showColumn.occurredTo },
    { title: 'Remove', idName: 'remove', show: showColumn.remove },
  ]

  return (
    <Modal
      open={showLinkedIncidents}
      onClose={() => setShowLinkedIncidents(false)}
      className={modalStyle}
      data-cy="linked-incident-modal"
    >
      <div style={{ display: 'flex', flexDirection: 'column', outline: 'none' }}>
        {/* Linked Incidents */}
        <LinkedIncidentTable
          handleIncidentOpening={handleIncidentOpening}
          incidents={linkedIncidents}
          headers={linkedHeaders}
          showColumn={showColumn}
          setShowColumn={setShowColumn}
          handleShowColumn={handleShowColumn}
          headerTitle={'Linked\xa0Incidents'}
          onCloseHandler={() => setShowLinkedIncidents(false)}
          type={"linked"}
          incidentId={incidentId}
          incidentIndex={incidentIndex}
          loading={linkedLoading || !linkedIncidents || !linkedData}
          removeIncident={handleRemoveLinkedIncident}
          locked={memoizedLocked}
          userRoles={userRoles}
        />
        {/* Related Incidents */}
        <LinkedIncidentTable
          handleIncidentOpening={handleIncidentOpening}
          incidents={relatedIncidents}
          headers={linkedHeaders}
          showColumn={showColumn}
          setShowColumn={setShowColumn}
          handleShowColumn={handleShowColumn}
          headerTitle={'Related\xa0Incidents'}
          onCloseHandler={() => setShowLinkedIncidents(false)}
          type={"related"}
          incidentId={incidentId}
          incidentIndex={incidentIndex}
          removeIncident={handleRemoveRelatedIncident}
          loading={linkedLoading || !linkedIncidents || !linkedData}
          locked={memoizedLocked}
          userRoles={userRoles}
        />
      </div>
    </Modal>
  );
}

export default LinkedIncidents;